const reportDB = require("../../../../../components/report/report-db");
const report = require("../../../../../components/report/report");
const style = require("../../../../../components/report/report-style");
const css = style.get();
const page = require("../../../../../components/page/page");
import { createChart } from "./chart/accountsPayable-page-chart";

let cachedReportDateFilter = null;

export function getCachedReportDateFilter() {
  return cachedReportDateFilter;
}

export function fetchAll(detail, callback) {
  const phpFile = "server/php/sql/report.php";
  if (detail.filterBy && detail.filterBy.endDate) {
    cachedReportDateFilter = {
      startDate: detail.filterBy.startDate || detail.filterBy.endDate,
      endDate: detail.filterBy.endDate,
    };
  } else {
    cachedReportDateFilter = null;
  }
  detail.inf = {
    entity: "provider",
    report: "account-payable-all",
    id: "dataDbid",
  };
  if (detail.sort) {
    detail.inf.sort_by = detail.sort.by;
    detail.inf.sort_dir = detail.sort.dir;
  }

  if (detail.search) {
    detail.inf.searchPayable = detail.search;
  }

  if (detail.filterBy) {
    detail.inf.startDate = detail.filterBy.startDate;
    detail.inf.endDate = detail.filterBy.endDate;
  }

  reportDB.select(detail, phpFile, (data) => {
    callback(data);
    createChart(data);
    detail.skipReportPage = true; // Skip the report page
    report.show(detail, () => {
      const pageTarget = document.getElementById("accountsPayable-page-right");

      const existingContent = pageTarget.querySelector(".accountsPayable-dataCont");
      if (existingContent) {
        existingContent.remove();
      }

      const body = generate(data);
      pageTarget.insertAdjacentHTML("beforeend", body);
    });
  });
}

export function fetchOne(detail, callback) {
  const phpFile = "server/php/sql/report.php";
  detail.inf = {
    entity: "provider",
    report: "account-payable-all-one",
    dbid: detail.dbid,
  };
  if (cachedReportDateFilter) {
    detail.inf.startDate = cachedReportDateFilter.startDate;
    detail.inf.endDate = cachedReportDateFilter.endDate;
  }
  reportDB.select(detail, phpFile, (data) => {
    callback(data);
  });
}

export function fetchUnpaidInvoices(detail, callback) {
  const phpFile = "server/php/sql/report.php";
  detail.inf = {
    entity: "provider",
    report: "account-payable-one",
    id: detail.dbid,
  };
  if (cachedReportDateFilter) {
    detail.inf.startDate = cachedReportDateFilter.startDate;
    detail.inf.endDate = cachedReportDateFilter.endDate;
  }

  reportDB.select(detail, phpFile, (data) => {
    callback(data);
  });
}
function generate(data) {
  var body = "";
  body += generateTop(data[0]);
  body += generateTable(data);
  body += `</div> <!-- dataCont -->`;
  body += `<div class="report-page">`;

  return body;
}

function generateTop(data) {
  var table = `
    <div class="dataCont accountsPayable-dataCont dn">
      <div ${css.title}>${data.company_name}</div>
      <div ${css.subtitle}>${data.provider ?? 'All'} Account Payable Aging Report As Of ${data.current_dateTime}</div>
  `;
  return table;
} /**/

function generateTable(data) {
  var totals = {
    current: 0,
    total_due_30_days: 0,
    total_due_31_to_60_days: 0,
    total_due_61_to_90_days: 0,
    total_due_over_90_days: 0,
    grandTotal: 0,
  };
  var nextFormat = 0;

  var table = `
    <h2 ${css.f15}>Providers Vs Aging Owned Amounts: This is a financial document that provides information about money 
      owed to a company by its customers or clients for goods or services provided on credit.</h2>
    <table ${css.table} class="dt-alterColor">
     <tr >
       <th ${css.th}>Provider</th>
       <th ${css.th}>Current</th>
       <th ${css.th}>30 days</th>
       <th ${css.th}>31 to 60 days</th>
       <th ${css.th}>61 to 90 days</th>
       <th ${css.th}>Over 90 days</th>
       <th ${css.th}>Total</th>   
    </tr> 
  `;

  for (let i = 0; i < data.length; i++) {
    let rowTotal = 0;
    let detailHtml = `data-detail='{"click": [ {"dest":"ripple" },  
        {"dest":"provider", "elem":"report", "reportType":"accountPayable", "entity":"provider", "dbid":"${data[i].provider_id}", "source":"dt" } ] }'`;

    totals.current += parseFloat(data[i].current.replace(/[$,]/g, ""));
    totals.total_due_30_days += parseFloat(
      data[i].total_due_30_days.replace(/[$,]/g, ""),
    );
    totals.total_due_31_to_60_days += parseFloat(
      data[i].total_due_31_to_60_days.replace(/[$,]/g, ""),
    );
    totals.total_due_61_to_90_days += parseFloat(
      data[i].total_due_61_to_90_days.replace(/[$,]/g, ""),
    );
    totals.total_due_over_90_days += parseFloat(
      data[i].total_due_over_90_days.replace(/[$,]/g, ""),
    );

    rowTotal =
      parseFloat(data[i].current.replace(/[$,]/g, "")) +
      parseFloat(data[i].total_due_30_days.replace(/[$,]/g, "")) +
      parseFloat(data[i].total_due_31_to_60_days.replace(/[$,]/g, ""));
    rowTotal +=
      parseFloat(data[i].total_due_61_to_90_days.replace(/[$,]/g, "")) +
      parseFloat(data[i].total_due_over_90_days.replace(/[$,]/g, ""));

    totals.grandTotal += rowTotal;

    table += `
      <tr ${rowStyle(i)}>
        <td class='tdClick' ${css.td} ${detailHtml} >${data[i].provider}</td>
        <td ${css.td} >${data[i].current}</td>
        <td ${css.td} >${data[i].total_due_30_days}</td>
        <td ${css.td} >${data[i].total_due_31_to_60_days}</td>
        <td ${css.td} >${data[i].total_due_61_to_90_days}</td>
        <td ${css.td} >${data[i].total_due_over_90_days}</td>
        <td ${css.td} >${cashVal(rowTotal)}</td>
      </tr> 
    `;
    nextFormat = i + 1;
  }

  //GRAND TOTAL
  totals.grandTotal =
    totals.current +
    totals.total_due_30_days +
    totals.total_due_31_to_60_days +
    totals.total_due_61_to_90_days +
    totals.total_due_over_90_days;

  //PRINITNG EACH COLUMM TOTAL
  table += `
    <tr ${rowStyle(nextFormat)}>
      <td ${css.totalLabel}>Total</td>
      <td ${css.totalCell}>${cashVal(totals.current)}</td>
      <td ${css.totalCell}>${cashVal(totals.total_due_30_days)}</td>
      <td ${css.totalCell}>${cashVal(totals.total_due_31_to_60_days)}</td>
      <td ${css.totalCell}>${cashVal(totals.total_due_61_to_90_days)}</td>
      <td ${css.totalCell}>${cashVal(totals.total_due_over_90_days)}</td>
      <td ${css.totalCell}>${cashVal(totals.grandTotal)}</td>
    </tr> 
  `;
  table += `</table>`;

  return table;
}
function cashVal(value) {
  return value.toLocaleString("en-US", { style: "currency", currency: "USD" });
}

function rowStyle(i) {
  if (i % 2 === 0) {
    return "";
  }
  return css.trGray;
}

export function buildPayableAllPrintHtml(data) {
  return generate(data);
}

function appendReportInfDates(inf, filters) {
  if (filters.startDate) inf.startDate = filters.startDate;
  if (filters.endDate) inf.endDate = filters.endDate;
  if (filters.useYear) inf.filterByYear = "1";
}

export function fetchPayableOneBundleForHub(filters, callback) {
  const phpFile = "server/php/sql/report.php";

  const detailTop = {
    inf: { entity: "provider", report: "account-payable-all-one", dbid: filters.dbid },
  };
  appendReportInfDates(detailTop.inf, filters);

  reportDB.select(detailTop, phpFile, (topData) => {
    if (!topData || !topData.length) {
      callback(null, null);
      return;
    }
    const detailLines = {
      inf: { entity: "provider", report: "account-payable-one", id: filters.dbid },
    };
    appendReportInfDates(detailLines.inf, filters);

    reportDB.select(detailLines, phpFile, (tableData) => {
      callback(topData, tableData || []);
    });
  });
}

function generateOneTop(data) {
  return `<div class="dataCont accountsPayable-one">
    <div ${css.title}>${data.company_name}</div>
    <div ${css.subtitle}>${data.provider} Account Payable Aging Report As Of ${data.current_dateTime}</div>
  `;
}

function payableOneCashVal(value) {
  return value.toLocaleString("en-US", {
    style: "currency",
    currency: "USD",
  });
}

function payableOneRowStyle(i) {
  if (i % 2 === 0) {
    return "";
  }
  return css.trGray;
}

function generateOneTable(agesData) {
  var totalDue = 0;

  var table = `
    <h2 ${css.f15}>${agesData[0].name + " Unpaid Bills"}: This is a financial document that provides a summary of the outstanding invoices and bills that a company owes to one Provider.</h2>
    <table ${css.table} >
      <tr>
        <th ${css.th}>Date</th>
        <th ${css.th}>Category</th>
        <th ${css.th}>code</th>   
        <th ${css.th}>Due Date</th>  
        <th ${css.th}>Due Amount</th>         
        <th ${css.th}>Original Amount</th>
      </tr> 
  `;

  if (agesData[0].ageDueAmount == null) {
    table += `
      <tr>
        <td ${css.td} colspan="6"  ><div align="center"><h3>No Due Bills Were Found.</h3></div></td>
      </tr> 
    `;
    table += `</table>`;
    return table;
  }

  for (let i = 0; i < agesData.length; i++) {
    table += `
      <tr>
        <td ${css.td} colspan="6" bgcolor="lightgray" >
          <div align="center">
            <div style="font-weight: bold;">${agesData[i].overdue_age + " " + agesData[i].ageDueAmount}</div>
          </div>
        </td>
      </tr> 
    `;

    totalDue += parseFloat(agesData[i].ageDueAmount.replace(/[$,]/g, ""));

    var ageUnpaidBill = JSON.parse(agesData[i].unpaidBill);

    for (let y = 0; y < ageUnpaidBill.length; y++) {
      let detailHtml = `data-detail='{"click": [ {"dest":"ripple" },
          {"dest":"report", "elem":"fullcont",  "act":"jump", 
          "actJump":"goToPurchase", "dtId":"purchase-dt", "toSearch":"${ageUnpaidBill[y].code}"  } ] }'`;

      table += `
        <tr ${payableOneRowStyle(i + y)}>
          <td ${css.td} >${ageUnpaidBill[y].date}</td>
          <td ${css.td} >${ageUnpaidBill[y].category}</td>
          <td class='tdClick' ${css.td} ${detailHtml} >${ageUnpaidBill[y].code}</td>
          <td ${css.td} >${ageUnpaidBill[y].due_date}</td>
          <td ${css.td} >${ageUnpaidBill[y].due_amount}</td>
          <td ${css.td} >${ageUnpaidBill[y].original_amount}</td>
        </tr>
      `;
    }
  }

  table += `
    <tr>
      <td ${css.td} colspan="5"  >
        <div align="right">
          <div style="font-weight: bold;">Total Due</div>
        </div>
      </td>
      <td ${css.td} >
          <div align="left">
            <div>${payableOneCashVal(totalDue)}</div>
          </div>
      </td>
    </tr> 
  `;
  table += `</table>`;

  return table;
}

export function buildPayableOnePrintHtml(topRows, detailRows) {
  if (!topRows || !topRows.length) {
    return "";
  }
  const top = topRows[0];
  let ages = detailRows;
  if (!ages || !ages.length) {
    ages = [
      {
        name: top.provider,
        ageDueAmount: null,
        unpaidBill: "[]",
        overdue_age: "",
      },
    ];
  }
  var body = "";
  body += generateOneTop(top);
  body += generateOneTable(ages);
  body += `</div> <!-- dataCont -->`;
  body += `<div class="report-page">`;
  return body;
}

